// extracted by mini-css-extract-plugin
export default {"root":"DashboardLayout_root__nDlKL","footer":"DashboardLayout_footer__SzVq5"};